import { render, staticRenderFns } from "./WhatsappConversations.vue?vue&type=template&id=0d185585&scoped=true&"
import script from "./WhatsappConversations.vue?vue&type=script&lang=js&"
export * from "./WhatsappConversations.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappConversations.vue?vue&type=style&index=0&id=0d185585&prod&lang=sass&"
import style1 from "./WhatsappConversations.vue?vue&type=style&index=1&id=0d185585&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d185585",
  null
  
)

export default component.exports